
import React from 'react';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { User } from 'lucide-react';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function AdminHeader() {
  const {
    adminUser,
    signOut
  } = useAdminAuth();
  
  return (
    <header className="border-b border-border p-4 flex items-center justify-between sticky top-0 z-30 bg-background">
      <div className="flex items-center gap-2">
        <div className="hidden md:block">
          <SidebarTrigger />
        </div>
        <div className="md:hidden">
          <Link to="/dashboard" className="flex items-center">
            <img 
              src="/lovable-uploads/6055e260-5182-4f1b-b156-c43d2ae1598d.png" 
              alt="DriveCourses Logo" 
              className="h-7 max-w-full"
            />
          </Link>
        </div>
      </div>
      
      <div className="flex items-center gap-3">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="flex items-center gap-2 rounded-full">
              <User className="h-4 w-4" />
              <span className="hidden md:inline-block">{adminUser?.email}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem 
              onClick={signOut} 
              className="cursor-pointer"
            >
              Log Out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
